
import { Component, Vue } from "vue-property-decorator";


@Component({
    components: {
    }
})
export default class OpenTongueResult extends Vue {
    url = decodeURIComponent(this.$route.query.url as string);
}
